<template>
  <div class="container">
    <div v-if="isMobile">
      <TheHeader />
      <div
        v-if="context.request.user.is_staff"
        class="d-flex justify-center mb-2"
      >
        <HeaderChangeFlavour />
      </div>
    </div>
    <div
      v-else
      class="header d-flex justify-space-between align-center mt-5"
    >
      <div class="header-col">
        <div class="d-flex justify-start align-center">
          <HeaderLanguageToggle
            v-if="context.available_languages.length"
            class="mr-3"
          />
          <HeaderTown />
        </div>
        <div v-if="context.request.user.is_staff">
          <HeaderChangeFlavour class="mt-2" />
        </div>
      </div>
      <div class="d-flex flex-column justify-center align-center header-col">
        <HeaderLogo />
        <div class="text-subtitle-1 text-secondary--text text-center">
          {{ filterIntcomma(context.stat.rates_total) }}
          {{ filterCase(context.stat.rates_total, [
            t('отзыв', options),
            t('отзыва', options),
            t('отзывов', options),
          ]) }}
        </div>
      </div>
      <div class="d-flex justify-end align-center header-col">
        <div
          v-if="context.request.country.is_russia"
          class="d-flex justify-end align-center"
        >
          <HeaderExpert class="mr-8" />
          <HeaderAnalyses class="mr-4" />
        </div>
        <HeaderAuth />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import I18NextVue from 'i18next'
import type { ContextStore } from 'src/layouts/core-layout/types'
import { useContextStore, useURLStore } from 'src/store'

import {
  HeaderTown,
  HeaderLogo,
  HeaderAuth,
  HeaderExpert,
  HeaderAnalyses,
  HeaderChangeFlavour,
  HeaderLanguageToggle,
} from 'src/layouts/core-layout/components/CoreHeader/components/index'
import TheHeader from 'src/layouts/core-layout/components/CoreHeader/components/mobile/TheHeader/TheHeader.vue'
import filterCase from 'common/filters/filterCase'
import filterIntcomma from 'common/filters/filterIntcomma'

const { context }: ContextStore = useContextStore()
const { urls, patch } = useURLStore()
const { t, language } = I18NextVue
const options = { ns: language }
const isMobile = context.flavour === 'mobile'

if (process.env.IS_SERVER && urls.town) {
  patch({ town: urls.town })
}
</script>

<style scoped lang="scss">
@import 'src/styles/index';

.header {
  height: 80px;

  &-col {
    flex: 1;
  }
}
</style>
